const spacing = factor => `${0.25 * factor}rem`;
const toRem = pixels => `${pixels / 16}rem`;

export default {
  spacing,
  toRem,
};
